<template>
  <main>
    <div class="row">
      <div class="col s12 l10 offset-l1 card-panel recargas" style="position: relative">
        <div class="row">
          <h3 style="text-align: center"> Comentarios por tipo de carrier</h3>
        </div>
        <div class="row">
          <div class="col s6 offset-s3">
            <div class="row" v-for="comment in comments">
              <div class="input-field col s12">
                <input type="text" v-model="comment.comment">
                <label>{{comment.carrier}}</label>
              </div>
            </div>
            <!-- <div class="row">
              <div class="input-field col s12">
                <input type="text" v-model="data.telcel">
                <label>Telcel</label>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12">
                <input type="text" v-model="data.movistar">
                <label>Movistar</label>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12">
                <input type="text" v-model="data.unefon">
                <label>Unefon</label>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12">
                <input type="text" v-model="data.att">
                <label>Att</label>
              </div>
            </div> -->
          </div>
        </div>
        <div class="row">
          <div class="col s3 offset-s9">
            <div class="waves-effect waves-light btn-large blue-grey darken-3" @click="send"
               >Enviar
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {getComments,postComment} from "@/api/comments"

export default {
  name: "comentariosCarier",
  data() {
    return {
      data: {
        telcel:'',
        movistar:'',
        unefon:'',
        att:'',
      },
      comments : []
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        M.AutoInit()

      })
    },

    send(){
      // console.log(`Enviando: `, this.telcel, this.movistar, this.unefon, this.att)
      postComment(this)
        .then(()=>{
          M.toast({
            html: "Comentarios guardados",
            classes: "rounded",
            displayLength: 4000,
          })
        })
        .catch((error)=>{
          console.log(error)
          M.toast({
            html: error,
            classes: "rounded",
            displayLength: 4000,
          })
        })
    },

  },
  mounted(){
    this.$nextTick(() => {
      getComments(this)
      .then(resp => {
        this.comments = resp.comments
        console.log(`resp: `, resp)

      })
      .catch((error) => {
        console.log(`error: `,error)
      })
    })
  }
}
</script>

<style scoped>

</style>